import { RecordId } from "config/config";
import { ProcessState } from "./dependencyVisualization.service";

export const actions = {
    STORE_DEPENDENCY_VISUALIZATION_DATA: "STORE_DEPENDENCY_VISUALIZATION_DATA",
    STORE_SELECTED_RESOURCES_NODES: "STORE_SELECTED_RESOURCES_NODES",
    CLEAR_ALL: "CLEAR_ALL",
};

export const initialState = {
    processState: {
        nodes: [],
        edges: [],
        resources: [],
    } as ProcessState,
    selectedResources: [] as RecordId[],
};

export default (
    state = initialState,
    {
        type,
        processState,
        selectedResources,
    }: { type: string; processState: ProcessState; selectedResources: RecordId[] }
) => {
    switch (type) {
        case actions.STORE_DEPENDENCY_VISUALIZATION_DATA: {
            return {
                ...state,
                processState: processState,
            };
        }

        case actions.STORE_SELECTED_RESOURCES_NODES: {
            return {
                ...state,
                selectedResources: selectedResources,
            };
        }

        case actions.CLEAR_ALL: {
            return {
                ...state,
                selectedResources: [],
                processState: { nodes: [], edges: [], resources: [] },
            };
        }

        default:
            return state;
    }
};
